import { defineComponent, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { usePermissionsStore } from '@/store/permissions.store';
import { useCashierSettingsStore } from '@/store/cashier-settings/cashier-settings.store';
import { Plus, Refresh } from '@element-plus/icons-vue';
import { CashierSettingsButtonName } from '@/models/cashier-settings/cashier-settings.model';
import { CASHIER_SETTINGS_PERMISSIONS } from '@/models/app-internal/permissions.model';

const icons = {
  Plus,
  Refresh,
};

export default defineComponent({
  name: 'ConfigListHeader',
  emits: ['show-add-country-dialog'],
  setup() {
    const { cashierSettingsPermissions } = usePermissionsStore();
    const cashierSettingsStore = useCashierSettingsStore();
    const { getCashierConfigList } = cashierSettingsStore;
    const { isCashierConfigListLoading } = storeToRefs(cashierSettingsStore);

    const isChangeCountrySettingsAvailable = computed<boolean>(() =>
      cashierSettingsPermissions[CASHIER_SETTINGS_PERMISSIONS.CREATE_CASHIER_CONFIG] &&
      cashierSettingsPermissions[CASHIER_SETTINGS_PERMISSIONS.UPDATE_CASHIER_CONFIG]);

    return {
      icons,
      CashierSettingsButtonName,
      isChangeCountrySettingsAvailable,
      getCashierConfigList,
      isCashierConfigListLoading,
    };
  },
});
